export default __webpack_public_path__ + "static/mandarin-oriental-condo-988955_1280-e5e9382cf53ad87d98d8020c8c6cb52b.png";